import React, { Component } from 'react'
import { Link } from 'react-router-dom'
class HeaderItems extends Component {
    render() {
        return (
            <div className="col-sm-4">
                <Link onClick={this.props.handleRedirect} className={`small ${this.props.styleClass}`} to={this.props.to ? this.props.to : '#'}>
                    <img src={this.props.imgLink} width="35" alt={this.props.altName} />
                    <p className="mt-1 w3-text-black">{this.props.items}</p>
                </Link>
            </div>
        )
    }
}
export default HeaderItems